export const LK_LINK = 'https://my.cian.ru/';

export const LK_MY_OFFERS_LINK = 'https://my.cian.ru/my-offers/';

export const REQUIREMENTS_FOR_XML_LINK = 'https://www.cian.ru/xml_import/doc/#common_cat';

export const TG_LINK = 'https://t.me/cian_realtor';

export const MAX_LINK = 'https://max.ru/cian_realtor';

export const VK_LINK = 'https://vk.com/cian_pro';

export const PRICE_PROMO_LINK = 'https://www.cian.ru/new_promo/price/';

export const PROMO_LINK = 'https://www.cian.ru/new_promo/';
